
import {ReactComponent as JavaLogo} from '../SVG files/java.svg';
import {ReactComponent as JavascriptLogo} from '../SVG files/javascript.svg';
import {ReactComponent as PythonLogo} from '../SVG files/python.svg';
import {ReactComponent as HTMLLogo} from '../SVG files/html5.svg';
import {ReactComponent as CSSLogo} from '../SVG files/css3.svg';
import {ReactComponent as SQLLogo} from '../SVG files/mysql.svg';
import {ReactComponent as BashLogo} from '../SVG files/gnubash.svg';


import {ReactComponent as ReactLogo} from '../SVG files/react.svg';
import {ReactComponent as TensorflowLogo} from '../SVG files/tensorflow.svg';
import {ReactComponent as PandasLogo} from '../SVG files/pandas.svg';
import {ReactComponent as TailWindCSSLogo} from '../SVG files/tailwindcss.svg';


import {ReactComponent as GitLogo} from '../SVG files/git.svg';
import {ReactComponent as GooglecloudLogo} from '../SVG files/googlecloud.svg';
import {ReactComponent as GooglesheetsLogo} from '../SVG files/googlesheets.svg';
import {ReactComponent as MicrosoftExcelLogo} from '../SVG files/microsoftexcel.svg';
import {ReactComponent as KaggleLogo} from '../SVG files/kaggle.svg';
import {ReactComponent as AnsibleLogo} from '../SVG files/ansible.svg';
import {ReactComponent as JenkinsLogo} from '../SVG files/jenkins.svg';
import {ReactComponent as BambooLogo} from '../SVG files/bamboo.svg';
import {ReactComponent as SeleniumLogo} from '../SVG files/selenium.svg';
import {ReactComponent as JupyterLogo} from '../SVG files/jupyter.svg';
import {ReactComponent as TableauLogo} from '../SVG files/tableau.svg';


function Skills() {
  return (
    <div id="Skills" >
      <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white text-center py-6">
        Skills
      </h1>
      <div className="grid grid-cols-2">
        <div className="shadow-lg py-10">
          <h1 className="sm:text-4xl text-l font-medium title-font mb-4 text-white text-center">
            Languages
          </h1>
          <div className="bg-gray-800 rounded mx-16 grid grid-cols-6 my-4">
            <PythonLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                Python
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 h-10 grid grid-cols-6 my-4">
            <JavaLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                Java
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 h-10 grid grid-cols-6 my-4">
            <JavascriptLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                Javascript
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 h-10 grid grid-cols-6 my-4">
            <HTMLLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                HTML5
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 h-10 grid grid-cols-6 my-4">
            <CSSLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                CSS3
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 h-10 grid grid-cols-6 my-4">
            <SQLLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                MySQL
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 h-10 grid grid-cols-6 my-4">
            <BashLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                Bash
            </span>
          </div>
          <h1 className="sm:text-4xl text-l font-medium title-font mb-4 text-white text-center">
            FrameWorks & Libraries
          </h1>
          <div className="bg-gray-800 rounded mx-16 h-10 grid grid-cols-6 my-4">
            <ReactLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                React
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 h-10 grid grid-cols-6 my-4">
            <TensorflowLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                TensorFlow
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 h-10 grid grid-cols-6 my-4">
            <PandasLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                Pandas
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 h-10 grid grid-cols-6 my-4">
            <TailWindCSSLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                Tailwind CSS
            </span>
          </div>
        </div>


        <div className="shadow-lg py-10">
          <h1 className="sm:text-4xl text-l font-medium title-font mb-4 text-white text-center">
            Tools
          </h1>
          <div className="bg-gray-800 rounded mx-16 grid grid-cols-6 my-4">
            <GitLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                Git
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 grid grid-cols-6 my-4">
            <GooglecloudLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                Google Cloud (Big Query)
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 grid grid-cols-6 my-4">
            <GooglesheetsLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                Google Sheets
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 grid grid-cols-6 my-4">
            <MicrosoftExcelLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                Microsoft Excel
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 grid grid-cols-6 my-4">
            <KaggleLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                Kaggle
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 grid grid-cols-6 my-4">
            <AnsibleLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                Ansible
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 grid grid-cols-6 my-4">
            <JenkinsLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                Jenkins
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 grid grid-cols-6 my-4">
            <BambooLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                Bamboo
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 grid grid-cols-6 my-4">
            <SeleniumLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                Selenium
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 grid grid-cols-6 my-4">
            <JupyterLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                Jupyter Notebooks
            </span>
          </div>
          <div className="bg-gray-800 rounded mx-16 grid grid-cols-6 my-4">
            <TableauLogo className="place-self-center w-8 h-8" />
            <span className="title-font text-2xl font-medium text-white col-span-5 align-text-bottom my-1">
                Tableau
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Skills;
